import React, { useState } from "react";
import { connect } from 'react-redux';
import { compose } from 'utils/WebUtils';
import clsx from 'classnames'
import { currentOrganization, currentUser, getOrgConfigurations } from 'redux/selectors';
import {
  Avatar,
  Toolbar,
  AppBar,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { List, ListItem, Tooltip } from '@material-ui/core';

import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';


import { NavLink, withRouter } from 'react-router-dom'

import { getMenuItems } from '../../../config';
import { getClientTablesConfig, sideNavOpen } from 'redux/selectors';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import logoImage from 'assets/images/chargebee-icon-orange.png';
import IconExpandLess from '@material-ui/icons/ExpandLess'
import IconExpandMore from '@material-ui/icons/ExpandMore'

import { setData2 } from 'redux/actions'
import { GolfCourse as StartedIcon, ArrowForward as ForwardIcon } from "@material-ui/icons";

const styles = theme => ({
  mobilelogo: {
    display: 'none',
  },
  mobileshowlogo: {
    display: 'block',
    paddingLeft: '0',
    paddingRight: '0',
    minHeight: '35px',
    '& .MuiAvatar-root': {
      padding: '0',
      marginTop: '15px',
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  },
  sideNavDockedOverride: {

    backgroundColor: theme.palette.background.dockedMenu,
    '& .MuiListItemText-root': {
      color: '#ffffff',

    },
    '& .MuiListItem-root': {
      "&:hover": {
        backgroundColor: "#782ea8 !important",
        minWidth: '35px',
      }
    },
    '& .MuiListItemIcon-root': {
      paddingRight: '0px',
      width: '35px'
    },
    '& .MuiButtonBase-root': {
      width: '35px',
      padding: '3px 0px',
    },
    '& .settingsubmenu': {
      '& .MuiListItemIcon-root': {
        marginRight: '0px'
      },
      '& .MuiListItem-root': {
        paddingTop: '2px',
        paddingBottom: '2px',
        paddingLeft: '4px',
        background: 'transparent',
        width: '100%',
        '& .MuiSvgIcon-root': {
          fill: '#eaeaf4',
        },
        "&:hover": {
          width: '100%',
        }

      },
      '& .MuiListItemText-root': {
        '& .MuiTypography-body1': {
          color: '#dccdff',
          fontWeight: '500'
        }
      },

    }
  },
  contentWrapper: {
    position: 'relative',
    overflow: 'hidden',
    flex: '1 1 100%',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    height: '100%'
  },
  content: {
    width: '100%',
    minWidth: '100%',
    height: '100%',
    minHeight: '100%',
    margin: '0',
    overflowY: 'auto',
    '-ms-overflow-style': 'none',
    '&::-webkit-scrollbar': {
      width: '0'
    }
  },

  list: {
    paddingTop: 0,
    paddingBottom: 0
  },
  listItemRoot: {
    // flexDirection: 'column',
    // alignItems: 'start',
    // display: 'flex',
    paddingBottom: 0,
    paddingTop: 0,
    color: 'white'
  },
  listItem: {
    textTransform: 'none',
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0,
    width: '100%',
    minHeight: 96,
    alignItems: 'center',
    boxSizing: 'border-box',
    paddingLeft: 16,
    paddingRight: 16
  },
  listItemActive: {
    backgroundColor: theme.palette.background.rl,
    fontSize: 14,
    fontWeight: 600,
    color: 'rgb(0,0,30)', '&hover': {
      backgroundColor: theme.palette.background.rl,
      fontWeight: 600
    },
    "& .MuiSvgIcon-root": {
      fill: 'black'
    },
    '& .MuiListItemText-root': {
      '& .MuiTypography-body1': {
        color: '#5E5F5F',
      }
    }

    // '& svg': {
    //   color: 'black'
    // },
    // '& div': {
    //   color: 'black !important',
    //   fontWeight: 700,
    // },
    // '& p': {
    //   color: 'black !important',
    //   fontWeight: 700,
    // }
  },
  listItemButtonLabel: {
    flexDirection: 'column'
  },
  listItemText: {
    flex: '1 1 100%',
    textTransform: 'none',
    fontSize: 14,
    lineHeight: 1.75,
    '&hover': {
      color: 'rgb(0,0,30)',
      fontWeight: 600
    }
  },
  logo: {
    paddingRight: theme.spacing(1),
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  avatar: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },

  listIcon: {
    "& .MuiSvgIcon-root": {
      width: '18px',
      marginLeft: '0px'
    },
    height: '18px',
    color: '#666678',
    marginLeft: 'auto',
    marginRight: 'auto',
    '&hover': {
      color: 'rgb(0,0,30)'
    }
  },
  getStartedListItemIconOverrides: {
    color: 'rgb(58, 0, 140)',
  },
  getStartedListItemTextOverrides: {
    color: 'rgb(58, 0, 140)',
  },
  listText: {
    fontSize: '15px'
  },
  item: {
    paddingTop: '3px',
    paddingBottom: '3px',
  },
  listItemIconOverrides: {
    color: 'rgb(0,0,30)',
    minWidth: theme.spacing(3),
    height: theme.spacing(3),
    paddingRight: 12,
  },
  listItemGuttersOverrides: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1)
  },
  listItemRootOverrides: {
    padding: '3px 8px',
    borderRadius: theme.spacing(0.5),
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '2px',
    position: 'relative',
    zIndex: '999',

  },
  minIconWidth: {
    minWidth: '32px',
  },
  subItem: {
    color: 'rgb(0, 0, 30)',
    fontSize: '0.75rem',
    fontWeight: 400
  },
  divider: {
    width: '100%',
    marginBottom: theme.spacing(1)
  },
  root: {
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1)
  }
});


class MenuSidenavCompact extends React.Component {

  handleOnClick = index => {
    this.setState({ activeIndex: index });
  };
  state = { anchor: null, open: null, openSettings: false, openReports: false };

  handleClose = () => {
    this.setState({ anchor: null, open: null });
  };

  handleClick = (event, title) => {
    if (title === 'Settings') {
        this.setState({ openSettings: !this.state.openSettings })
    } else {
        this.setState({ openReports: !this.state.openReports })
    }
  }

  showGetStarted = () => {
    const { history } = this.props;

    history && history.push('/');

    setData2('showWelcomeTour', true)
  }

  render() {
    const { classes, currentUser, currentOrganization, clientTables, id, isSideNavOpen, orgConfig } = this.props;
    const { anchor, open, openSettings, openReports } = this.state;
    const menuProps = { clientTables, currentUser, open: isSideNavOpen, orgConfig };
    const menuItems = getMenuItems(undefined, menuProps);


    return (
      <div id={id} className={isSideNavOpen ? classes.contentWrapper : clsx(classes.contentWrapper, classes.sideNavDockedOverride)}>
        <div className={classes.content}>
          <Toolbar className={isSideNavOpen ? `${classes.mobilelogo}` : classes.mobileshowlogo}>
            <a href="https://app.chargebee.com/login"> <Avatar
              className={classes.logo} src={logoImage} /></a>
          </Toolbar>
          <div className={classes.root}>
            <List component="nav" disablePadding>
              {!currentOrganization.id.startsWith('6') && !currentOrganization.id.startsWith('7') &&
                <>
                  <ListItem
                    button
                    exact='true'
                    onClick={this.showGetStarted}
                    activeclassname={classes.listItemActive}
                    classes={{ root: classes.listItemRootOverrides, gutters: classes.listItemGuttersOverrides }}
                    key={'get_started'}>
                    <ListItemIcon classes={{ root: classes.listItemIconOverrides }}>
                      <StartedIcon className={isSideNavOpen ? classes.getStartedListItemIconOverrides : classes.listIcon} />
                    </ListItemIcon>

                    <ListItemText>
                      <Typography className={isSideNavOpen ? clsx(classes.listItemText, classes.getStartedListItemTextOverrides) : classes.listItemText}>Get Started</Typography>
                    </ListItemText>
                    <ForwardIcon fontSize={'small'} className={isSideNavOpen ? classes.getStartedListItemIconOverrides : classes.listIcon} />
                  </ListItem>
                </>}
              {menuItems.map(item => {
                const isVisible = item.visible(currentOrganization, menuProps)

                if (isVisible)
                  return (
                    item.subItem ?
                      <Tooltip title={isSideNavOpen ? '' : item.title} placement="right">
                        <ListItem classes={{ root: classes.listItemRootOverrides, gutters: classes.listItemGuttersOverrides }}>
                          <ListItemText
                            disableTypography
                            primary={
                              <Typography type="body2" className={classes.subItem}>
                                {item.title}Now working me start this ticket but please explain this ticket
                              </Typography>}
                          />
                        </ListItem> </Tooltip> :
                      item.href ?
                        <Tooltip key={item.title} title={isSideNavOpen ? '' : item.title} placement="right">
                          <ListItem
                            button
                            exact={true}
                            activeclassname={classes.listItemActive}
                            className={classes.listItemText}
                            classes={{ root: classes.listItemRootOverrides, gutters: classes.listItemGuttersOverrides }}
                            component={NavLink}
                            to={item.href}
                            key={item.title}
                          >
                            <ListItemIcon classes={{ root: classes.listItemIconOverrides }}>
                              {item.icon && <span className={classes.listIcon}>{item.icon}</span>}
                            </ListItemIcon>
                            <ListItemText disableTypography>
                              {item.title}
                            </ListItemText>
                          </ListItem>
                        </Tooltip>

                        :
                        item.children &&
                        <div key={item.title}>
                          <ListItem
                            button
                            onClick={(e) => { this.handleClick(e, item.title) }}
                            className={item.title === 'Settings' ? openSettings ? `${classes.menuItem} setMenuActive` : classes.menuItem : openReports ? `${classes.menuItem} setMenuActive` : classes.menuItem}
                            classes={{ root: classes.listItemRootOverrides, gutters: classes.listItemGuttersOverrides }}
                            activeclassname={classes.listItemActive}
                            exact='true'
                            onMouseEnter={() => {
                              if (!isSideNavOpen) {
                                if (item.title === 'Settings') {
                                    this.setState({ openSettings: !this.state.openSettings })
                                } else {
                                    this.setState({ openReports: !this.state.openReports })
                                }
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (!isSideNavOpen) {
                                if (item.title === 'Settings') {
                                    this.setState({ openSettings: !this.state.openSettings })
                                } else {
                                    this.setState({ openReports: !this.state.openReports })
                                }
                              }
                            }}
                          >

                            <ListItemIcon
                              classes={{ root: classes.listItemIconOverrides }}>
                              {item.icon && <span className={classes.listIcon}>{item.icon}</span>}
                            </ListItemIcon>

                            <ListItemText
                              disableTypography
                              primary={
                                <Typography type="body2" className={classes.listItemText}>
                                  {item.title}
                                </Typography>}
                            />
                            {item.title === 'Settings' ? openSettings ? <IconExpandLess /> : <IconExpandMore /> : openReports ? <IconExpandLess /> : <IconExpandMore />}
                          </ListItem>
                          <Collapse
                            onMouseEnter={(event) => {
                              if (!isSideNavOpen) {
                                if (item.title === 'Settings') {
                                    this.setState({ openSettings: true })
                                } else {
                                    this.setState({ openReports: true })
                                }
                              }
                            }}
                            onMouseLeave={(event) => {
                              if (!isSideNavOpen) {
                                if (item.title === 'Settings') {
                                    this.setState({ openSettings: !this.state.openSettings })
                                } else {
                                    this.setState({ openReports: !this.state.openReports })
                                }
                              }
                            }}
                            className={!isSideNavOpen ? 'settingsubmenu' : ''} in={item.title === 'Settings' ? openSettings : openReports} timeout="auto" unmountOnExit>
                            <Divider />
                            <List component="nav" disablePadding>
                              {item.children.map(child => {
                                return <ListItem
                                  button
                                  exact={true}
                                  activeclassname={classes.listItemActive}
                                  className={classes.item}
                                  component={NavLink}
                                  to={child.href}
                                  key={child.title}

                                >
                                  <ListItemIcon classes={{ root: classes.listItemIconOverrides }}>
                                    {child.icon && <span className={classes.listIcon}>{child.icon}</span>}
                                  </ListItemIcon>
                                  <ListItemText
                                    disableTypography
                                    primary={
                                      <Typography type="body2" className={classes.listItemText}>
                                        {child.title}
                                      </Typography>
                                    }
                                  />

                                </ListItem>
                              })}
                            </List>
                          </Collapse>
                        </div>
                  )
              })}
            </List>
          </div>
        </div>
      </div>
    );
  }
}

MenuSidenavCompact.propTypes = {
  classes: PropTypes.shape({}).isRequired
};

function mapStateToProps(state) {
  const isSideNavOpen = sideNavOpen(state)
  if (isSideNavOpen === null) return null
  const toReturn = {
    orgConfig: getOrgConfigurations(state),
    currentUser: currentUser(state),
    currentOrganization: currentOrganization(state),
    clientTables: getClientTablesConfig(state),
    isSideNavOpen: sideNavOpen(state),
  }
  return toReturn
}

export default compose(
  withRouter,
  withStyles(styles),
  connect(mapStateToProps, {}))(MenuSidenavCompact);
